import api from './axiosInstance';

export const connectToDiscord = async (user, token) => {
    const response = await api.post(`/connectToDiscord/${user._id}`, { token });
    return response.data;
};

export const connectToTelegram = async (user, token, chatId) => {
    const response = await api.post(`/connectToTelegram/${user._id}`, { token, chatId });
    return response.data;
};

export const disconnectFromGoogle = async (user) => {
    const response = await api.get(`/disconnectFromGoogle/${user._id}`);
    return response.data;
};